import { Icon, Text, Badge } from "@oysterhr/ui"

import { useTranslation } from "react-i18next"
import { CountryLiabilityTier } from "../../utils"
import { ComponentProps } from "react"

export interface CountryLiabilityProps {
  link?: string
  tier?: CountryLiabilityTier
}

export function CountryLiability({ tier, link }: CountryLiabilityProps) {
  const { t } = useTranslation("components/Quote")
  const getBadgeProps = (): {
    variation: ComponentProps<typeof Badge>["variation"]
    text: string
  } => {
    switch (tier) {
      case "HIGH":
        return {
          variation: "error",
          text: t(tier),
        }
      case "MEDIUM":
        return {
          variation: "warning",
          text: t(tier),
        }
      case "LOW":
        return {
          variation: "success",
          text: t(tier),
        }
      default:
        return {
          variation: "gray",
          text: "Unknown",
        }
    }
  }

  const { variation, text } = getBadgeProps()

  return (
    <div className="flex flex-row items-center space-x-2">
      <Text size="small" className="text-xs text-gray-400 md:text-sm">
        {t("liabilityLevel")}:
      </Text>
      <Badge variation={variation} className="text-xs md:text-sm">
        {text}
      </Badge>
      <a href={link} target="_blank" className="flex flex-row items-center space-x-1">
        <Text size="small" className="text-xs text-primary-base underline md:text-sm">
          {t("learnMore")}
        </Text>
        <Icon size="sm" name="ArrowSquareOut" />
      </a>
    </div>
  )
}
